import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({

    st0: {
        fill: '#1CB1F9',
    },

    st1: {
        fill: '#FFFFFF',
    },

    st2: {
        fontFamily: 'Roboto, sans-serif',
        // fontFamily: 'Open Sans, sans-serif',
    },

    st3: {
        fontSize: '15px',
        // fontWeight: '600',
    },

    st4: {
        clipPath: 'url(#SVGID_2_)',
    },

    st12: {
        fill: '#1CB1F9',
    },
}));
